/**
 * api_key/v1/api_key.proto
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * TokenStatus represents the lifecycle state of an access token.  Statuses 1-4 are persistent states stored in the database. Statuses 5-6 are ephemeral: returned in ClaimToken responses to indicate a temporal access-window condition without mutating stored state.   - TOKEN_STATUS_UNCLAIMED: Token has not been claimed yet.  - TOKEN_STATUS_CLAIMED: Token has been successfully claimed.  - TOKEN_STATUS_EXPIRED: Token has passed its expires_at time. Persisted to DB on detection.  - TOKEN_STATUS_REVOKED: Token has been explicitly revoked by an admin.  - TOKEN_STATUS_NOT_YET_ACTIVE: Claim attempted before access_window_start. Token remains UNCLAIMED in DB.  - TOKEN_STATUS_ACCESS_WINDOW_ENDED: Claim attempted after access_window_end. Token remains UNCLAIMED in DB.
 */
export const V1TokenStatus = {
  TokenStatusUnspecified: 'TOKEN_STATUS_UNSPECIFIED',
  TokenStatusUnclaimed: 'TOKEN_STATUS_UNCLAIMED',
  TokenStatusClaimed: 'TOKEN_STATUS_CLAIMED',
  TokenStatusExpired: 'TOKEN_STATUS_EXPIRED',
  TokenStatusRevoked: 'TOKEN_STATUS_REVOKED',
  TokenStatusNotYetActive: 'TOKEN_STATUS_NOT_YET_ACTIVE',
  TokenStatusAccessWindowEnded: 'TOKEN_STATUS_ACCESS_WINDOW_ENDED',
} as const;
export type V1TokenStatus = (typeof V1TokenStatus)[keyof typeof V1TokenStatus];
